import { IError } from '~src/httpClient/serverApi/types/IError';
import { CommonErrorCode } from '~src/ts/helpers/ErrorCodes';
import { L10n } from '~src/ts/L10n/L10n';
import { Messages } from '~src/codegen/Localize';
import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { IDataAlertBase } from '~src/ts/models/IDataAlertInfo';

export namespace DataAlertErrors {
  export function errorDetailsFor(dataAlertErrorItem: IErrorItem<IDataAlertBase>): IErrorDetail {
    return {
      itemName: dataAlertErrorItem.item.name,
      errorMessage: errorMessageFor(dataAlertErrorItem.error, dataAlertErrorItem.item.name)
    };
  }

  function errorMessageFor(error: IError, dataAlertName: string = '') {
    switch (error.code) {
      case CommonErrorCode.DataAlertNotFound:
        return Messages.errorDataAlertNotFound({ ALERT_NAME: L10n.elideIfLong(dataAlertName) });
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorDataAlertInsufficientPermissions();
      case CommonErrorCode.SiteUserNotFound:
        return Messages.errorUserNotFound();
      default:
        return Messages.errorUnknown();
    }
  }
}